<template>
  <div class="result-page">
    <div class="result-page-content">
      <img class="info-img" src="../../../public/img/circle.png" alt="" />
      <p v-if="status === 'success'" class="text1">投递成功</p>
      <p v-if="status === 'fail'" class="text1">
        <span>您已在该渠道投递过该职位</span>
      </p>
      <p class="text2">如果通过简历筛选，HR会在1-3个工作日联系你</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'result-page',
  components: {},
  props: {
    value: Boolean,
  },
  data() {
    return {}
  },
  computed: {},
  created() {
    this.status = this.$route.params.status
  },
  methods: {},
}
</script>
<style lang="less" scoped>
.font(@size:14px, @lh: 22px,@color: rgba(0, 0, 0, 0.45)) {
  font-size: @size;
  line-height: @lh;
  color: @color;
}
.result-page {
  height: 100%;
  background-color: #f0f2f5;
  padding: 20px 0 43px;
  .result-page-content {
    display: flex;
    height: 100%;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    max-width: 1200px;
    background-color: #fff;
    margin: 0 auto;
    .info-img {
      margin-top: 205px;
      width: 87px;
      height: 87px;
    }
    .text1 {
      .font(20px, 22px, #222831);
      margin-top: 23px;
      text-align: center;
      font-weight: 500;
    }
    .text2 {
      margin-top: 12px;
      .font(14px, 22px, rgba(0, 0, 0, 0.45));
      & > span:nth-child(1) {
        .font(20px, 22px, rgba(0, 0, 0, 0.45));
      }
      & > span:nth-child(2) {
        margin-left: 5px;
        .font(20px, 22px, #222831);
      }
    }
    .btn {
      margin-top: 32px;
      width: 120px;
      height: 32px;
    }
  }
}
@media screen and (max-width: 1200px) {
  .result-page {
    .result-page-content {
      background-color: #f0f2f5;
      .info-img {
        margin-top: 0.25rem;
        width: 0.8rem;
        height: 0.8rem;
      }
      .text1 {
        .font(0.2rem, 0.22rem, #222831);
        margin-top: 0.2rem;
        text-align: center;
        font-weight: 500;
      }
      .text2 {
        margin-top: 0.08rem;
        .font(0.14rem, 0.22rem, rgba(0, 0, 0, 0.45));
        & > span:nth-child(1) {
          .font(20px, 22px, rgba(0, 0, 0, 0.45));
        }
        & > span:nth-child(2) {
          margin-left: 5px;
          .font(20px, 22px, #222831);
        }
      }
      .btn {
        margin-top: 0.46rem;
        width: 1.2rem;
        height: 0.32rem;
        background-color: #f0f2f5 !important;
      }
    }
  }
}
</style>
